var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Áreas")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("table", { staticClass: "table is-fullwidth" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.loading
          ? _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  { staticClass: "has-text-centered", attrs: { colspan: "4" } },
                  [_c("loading-spin")],
                  1
                ),
              ]),
            ])
          : _c(
              "tbody",
              [
                _vm._l(_vm.areas, function (area) {
                  return _c("tr", { key: area.id, attrs: { id: area.id } }, [
                    _c("td", [_vm._v(_vm._s(area.id))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(area.nombre))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(area.dependencia ? area.dependencia.nombre : "-")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "field has-addons is-pulled-right" },
                        [
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "span",
                              {
                                staticClass: "button is-small",
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditModal(area)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-edit fa-lg" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "button is-outlined is-small is-danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeleteModal(area)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-trash fa-lg" })]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.areas.length == 0 ? _c("tr", [_vm._m(1)]) : _vm._e(),
              ],
              2
            ),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.confirmEditModal, width: 640, scroll: "keep" },
          on: {
            "update:active": function ($event) {
              _vm.confirmEditModal = $event
            },
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("p", { staticClass: "card-header-title" }, [
                _vm._v("Renombrar área"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "field has-addons" }, [
                _c("p", { staticClass: "control is-expanded" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newNombre,
                        expression: "newNombre",
                      },
                    ],
                    ref: "nombre",
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      required: "",
                      placeholder: "Ingrese un nuevo nombre para el área",
                    },
                    domProps: { value: _vm.newNombre },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.confirmEditArea()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.newNombre = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _vm.renombroInvalidoMessage
                ? _c("p", { staticClass: "help has-text-danger" }, [
                    _vm._v(_vm._s(_vm.renombroInvalidoMessage)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-footer" }, [
              _c(
                "a",
                {
                  staticClass: "card-footer-item",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.confirmEditModal = false
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _vm._v(" "),
              !_vm.renombroInvalido
                ? _c(
                    "a",
                    {
                      staticClass:
                        "card-footer-item has-text-weight-bold is-uppercase",
                      on: {
                        click: function ($event) {
                          return _vm.confirmEditArea()
                        },
                      },
                    },
                    [_vm._v("Renombrar")]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.confirmDeleteModal, width: 640, scroll: "keep" },
          on: {
            "update:active": function ($event) {
              _vm.confirmDeleteModal = $event
            },
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-content" }, [
              _c("h1", { staticClass: "title is-3" }, [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v(" Atención\n      "),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "subtitle is-6" }, [
                _vm._v(
                  "\n        Está por realizar una acción sin retorno. ¿Confirma que desea eliminar el área "
                ),
                _c("b", [
                  _vm._v(_vm._s(_vm.areaToDelete && _vm.areaToDelete.nombre)),
                ]),
                _vm._v("?\n      "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-clearfix" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-dark is-outlined",
                    on: {
                      click: function ($event) {
                        _vm.confirmDeleteModal = false
                      },
                    },
                  },
                  [_vm._v("\n          Cancelar\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-danger is-pulled-right",
                    on: {
                      click: function ($event) {
                        return _vm.confirmDeleteArea()
                      },
                    },
                  },
                  [_vm._v("\n          Eliminar\n        ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("paginator", {
        ref: "paginator",
        attrs: { resource: _vm.url, loading: _vm.loading },
        on: {
          update: _vm.updateResource,
          "update:loading": function ($event) {
            _vm.loading = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Área")]),
        _vm._v(" "),
        _c("th", [_vm._v("Depende de")]),
        _vm._v(" "),
        _c("th", { staticClass: "has-text-right", attrs: { width: "100" } }, [
          _vm._v("Acciones"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "has-text-centered", attrs: { colspan: "3" } },
      [
        _c("section", { staticClass: "section is-mono" }, [
          _c("span", { staticClass: "tag is-rounded is-medium" }, [
            _c("i", { staticClass: "fas fa-info fa-fw" }),
            _vm._v(" Sin áreas para mostrar\n            "),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }